import { useEffect, useState } from "react";

/**
 * useOnlineStatus — predictable online/offline awareness.
 *
 * Used by the Shell sync badge and offline banners. We listen to native
 * `online`/`offline` events. No background polling; no noisy retry logic.
 * The platform should feel rugged + predictable, not chatty.
 */
export function useOnlineStatus() {
  const [online, setOnline] = useState(
    typeof navigator !== "undefined" ? navigator.onLine !== false : true,
  );

  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => {
      window.removeEventListener("online", on);
      window.removeEventListener("offline", off);
    };
  }, []);

  return online;
}
